import { RadioCard } from '@noorden-insurtech/alba-design-system';
import { LucideIcon } from 'lucide-react';

interface UserTypeRadioItemProps {
  value: 'insurer' | 'advisory' | 'broker';
  icon: LucideIcon;
  label: string;
  description: string;
}

export function UserTypeRadioItem({
  value,
  icon: Icon,
  label,
  description,
}: UserTypeRadioItemProps) {
  return (
    <RadioCard.Item value={value}>
      <RadioCard.ItemControl>
        <RadioCard.ItemIcon>
          <Icon />
        </RadioCard.ItemIcon>
        <RadioCard.RadioButton />
      </RadioCard.ItemControl>
      <RadioCard.ItemContent>
        <RadioCard.ItemText>{label}</RadioCard.ItemText>
        <RadioCard.ItemDescription>{description}</RadioCard.ItemDescription>
      </RadioCard.ItemContent>
      <RadioCard.ItemHiddenInput />
    </RadioCard.Item>
  );
}
